import * as types from '../types/collectionTypes';

const initialState = {
  list: [],
  listLoading: false,
  listError: null,
  /** Raw API collection document (includes `products`), same contract as GET /collections/:slug */
  detail: null,
  detailLoading: false,
  /** `{ message, status? }` or legacy string (read defensively in UI) */
  detailError: null,
};

const collectionReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_COLLECTIONS_REQUEST:
      return { ...state, listLoading: true, listError: null };
    case types.FETCH_COLLECTIONS_SUCCESS:
      return {
        ...state,
        listLoading: false,
        list: Array.isArray(action.payload) ? action.payload : [],
        listError: null,
      };
    case types.FETCH_COLLECTIONS_FAILURE:
      return {
        ...state,
        listLoading: false,
        listError:
          typeof action.payload === 'string'
            ? action.payload
            : action.payload?.message || 'Failed to load collections',
      };

    case types.FETCH_COLLECTION_DETAIL_REQUEST:
      return {
        ...state,
        detailLoading: true,
        detailError: null,
        detail: null,
      };
    case types.FETCH_COLLECTION_DETAIL_SUCCESS:
      return {
        ...state,
        detailLoading: false,
        detail: action.payload ?? null,
        detailError: null,
      };
    case types.FETCH_COLLECTION_DETAIL_FAILURE:
      return {
        ...state,
        detailLoading: false,
        detailError: action.payload ?? { message: 'Failed' },
        detail: null,
      };

    case types.CLEAR_COLLECTION_DETAIL:
      return {
        ...state,
        detail: null,
        detailError: null,
        detailLoading: false,
      };

    default:
      return state;
  }
};

export default collectionReducer;
